export const name = "Avatar";

export const importDocs = `
import { Avatar, AvatarFallback, AvatarImage } from "/components/ui/avatar";
`;

export const usageDocs = `
<Avatar>
  <AvatarImage src="https://github.com/nutlope.png" />
  <AvatarFallback>CN</AvatarFallback>
</Avatar>
`;
